import shrink from '../../assets/shrink.svg';
import { useSidebar } from '../../context/SidebarContext';
import { BottomMenu } from './components/BottomMenu';
import { Divider } from './components/Divider';
import { Logo } from './components/Logo';
import { MenuLinks } from './components/MenuLinks';

const Sidebar: React.FC = () => {
  const { isSidebarOpen, toggleSidebar } = useSidebar();

  return (
    <div className="sidebar-nav fixed left-0 top-0 h-screen bg-[#FAFAFA] transition-all duration-300 ease-in-out z-40 font-inter">
      <nav className="flex flex-col h-full border border-[#EEEEEE] relative">
        <div className='flex bg-[#FFFFFF] h-[49px] justify-between items-center border-b border-[#EEEEEE]'>
          <Logo isOpen={isSidebarOpen} />
          {isSidebarOpen && (
            <div className="pr-[12px]">
              <img src={shrink} alt="shrink" 
                className="w-[18px] h-[18px] text-[#222222] transition-colors duration-200 hover:border-[1px] hover:rounded-[4px] hover:border-[#E5E5E5] active:text-[#E5E5E5] active:bg-[#222222] active:rounded-[4px] cursor-pointer"
                onClick={toggleSidebar}
              />
            </div>
          )}
        </div>
        <div className={`flex flex-col ${!isSidebarOpen ? 'px-[8px]' : 'px-[12px]'}`}>
          <div className="flex flex-col items-center gap-[8px] pt-[8px]">
            <MenuLinks isOpen={isSidebarOpen} />
          </div>
        </div>
        <div className="flex flex-col items-center mt-auto justify-end mb-[8px]">
          <Divider isOpen={isSidebarOpen} className="bg-[#EEEEEE] w-full"/>
          <BottomMenu isOpen={isSidebarOpen} />
        </div>
      </nav>
    </div>
  );
};

export default Sidebar;
